import "./styles/Header.scss";
import { AppContext, ExAppContext } from '../Context';
import { App_ViewModeMap, Member_TypeMap, MemberUser_TypeMap, Payment_StatusMap, System_DeviceOrientationMap } from "../assets/keyMap";
import { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { useLocation, useHistory } from "react-router";
import { isPlatform } from "@ionic/react";

//components
import ToggleSlider from "./ToggleSlider";

//classes
import MemberUser from '../classes/memberUser';
import Broadcast from "../classes/broadcast";
import MemberType from "../exClasses/memberType";
import CommitteeType from "../exClasses/committeeType";
import MembershipContract from '../exClasses/membershipContract';
import Payment from '../exClasses/payment';

//controllers
import DatabaseInterfaceController from "../controllers/DatabaseInterfaceController";

//mui
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationActiveIcon from '@mui/icons-material/NotificationsActive';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
// import PlayArrow from '@mui/icons-material/PlayArrow'; ---deprecated

//graphics
import PPKMLogo from '../assets/images/logos/ppkmLogo1.jpg';
import PPKMLogoTransparent from '../assets/images/logos/ppkm-logo-transparent.png';
import HeaderBannerBg from '../assets/images/general/header-banner-bg.jpg';

const nonstate = {
    headerModeMap: {
        '/Blank': 'main',
        '/Home': 'main',
        '/ViewNotifications': 'sub',
        '/ViewEvents': 'sub',
        '/Events': 'sub',
        '/MyEvents': 'sub',
        '/EventRegistrations': 'sub',
        '/Profile': 'sub',
        '/ManageMembership': 'sub',
        '/EditProfile': 'sub',
        '/ChangePassword': 'sub',
        '/ResetPin': 'sub',
        '/ECert': 'sub',
        // '/MembershipRenewal': 'sub', --- deprecated
        // '/SecondaryAccount': 'sub', --- deprecated
        '/MembersList': 'sub',
        '/Miscellaneous': 'sub',
        '/ViewEventGallery': 'sub',
        '/ViewDocuments': 'sub',
        '/ViewMeetings': 'sub',
        '/ViewPolls': 'sub',
        '/ManageNotifications': 'sub',
        '/ManageEventAttachments': 'sub',
        '/SocialMedia': 'sub'
    }
}

interface Props {
    user: MemberUser,
    headerBackAction: any, headerTitle: string
}

const Header: React.FC<Props> = ({ user, headerBackAction, headerTitle }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [headerMode, SetHeaderMode] = useState('main');
    const [headerVisibility, SetHeaderVisibility] = useState(false);
    const [unreadBroadcastCount, SetUnreadBroadcastCount] = useState<number>(0);
    const [contractPayments, SetContractPayments] = useState<Payment[]>([] as Payment[]);
    // const [graceCountdownTime, SetGraceCountdownTime] = useState<number>(0); ---deprecated
    //refs - vars
    // const graceCountdownTimeRef = useRef<number>(graceCountdownTime); ---deprecated
    //refs - interval
    // const gracePeriodCountdownIntervalRef = useRef<any>(null); ---deprecated
    //router objs
    const location = useLocation();
    const history = useHistory();
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('HeaderTest: ' + appContext.headerTitle);
    // }, [appContext.headerTitle]);

    //initialization
    // useEffect(() => {s
    //     return (() => {
    //         if (gracePeriodCountdownIntervalRef.current != null) {
    //             clearInterval(gracePeriodCountdownIntervalRef.current);
    //         }
    //     });
    // }, []); ---deprecated

    //watch for location patname update headerMode
    useEffect(() => {
        const re_pathname = '/' + location.pathname.split('/')[1];
        SetHeaderMode(nonstate.headerModeMap[re_pathname as keyof typeof nonstate.headerModeMap])
        SetHeaderVisibility(false);
        setTimeout(() => {
            SetHeaderVisibility(true);
        }, 250);

        //header title control
        HeaderTitleControl(location.pathname);
    }, [location.pathname, exAppContext.viewMode]);

    //watch for broadcasts change update notification unreadCount
    useEffect(() => {
        let count = 0;
        appContext.broadcasts.map((broadcast: Broadcast) => {
            if (broadcast.read == false)
                count += 1;
        });
        SetUnreadBroadcastCount(count);
    }, [appContext.broadcasts]);

    //watch for membershipContracts fetched, fetch membershipContractPayments
    useEffect(() => {
        const paymentIDs = [] as string[];
        exAppContext.membershipContracts.map((contract: MembershipContract) => {
            paymentIDs.push(contract.paymentID);
        });
        databaseInterfaceController.Queue('fetchPayments', [
            ['fetchPayments', 'true'],
            ['paymentIDs', paymentIDs.join(',')]
        ]);
    }, [exAppContext.membershipContracts]);

    //watch for membership payments fetched, get last contracts and check for expiration
    useEffect(() => {
        if (
            location.pathname == '/Home'
            && exAppContext.membershipContracts.length > 0
            && contractPayments.length > 0
        ) {
            const lastRenewedContract = GetLastRenewedContract(exAppContext.membershipContracts);
            if (lastRenewedContract.max_term != null) {
                const dateNow = new Date();
                const diff = lastRenewedContract.max_term.getTime() - dateNow.getTime();
                if (diff <= 0) {
                    //is expired, initiate gracePeriod countdown
                    const graceExpiredDate = new Date();
                    graceExpiredDate.setMonth(0);
                    graceExpiredDate.setDate(31);

                    const timeNow = new Date().getTime();
                    const timeToExpired = graceExpiredDate.getTime() - timeNow;

                    // graceCountdownTimeRef.current = Math.round(timeToExpired/1000); /**millis to seconds */
                    // SetGraceCountdownTime(graceCountdownTimeRef.current);

                    // if(gracePeriodCountdownIntervalRef.current != null)
                    //     clearInterval(gracePeriodCountdownIntervalRef.current);

                    // gracePeriodCountdownIntervalRef.current = setInterval(() => {
                    //     if(graceCountdownTimeRef.current - 1 > 0) {
                    //         graceCountdownTimeRef.current -= 1;
                    //         SetGraceCountdownTime(graceCountdownTimeRef.current);
                    //     } else {
                    //         //grace period end, auto logout
                    //         clearInterval(gracePeriodCountdownIntervalRef.current);
                    //         gracePeriodCountdownIntervalRef.current = null;
                    //         //auto signout prompt
                    //         appContext.SetPopupMessage('Your membership has been suspended.');
                    //         appContext.SetPopupButtons(['Sign Out']);
                    //         appContext.SetPopupActions([() => {
                    //             appContext.SetWaitScreenShouldShow(true);
                    //             appContext.SetWaitScreenMessage('Signing out please wait');
                    //             setTimeout(() => {
                    //                 appContext.SetWaitScreenShouldShow(false);
                    //                 appContext.SetUser({} as MemberUser);
                    //                 appContext.SetPopupMessage('Your account has been safely signed out.');
                    //             }, 3000);
                    //         }]);
                    //     }
                    // }, 1000); ---deprecated
                }
            }
        } /*else if(gracePeriodCountdownIntervalRef.current != null) {
            clearInterval(gracePeriodCountdownIntervalRef.current);
            gracePeriodCountdownIntervalRef.current = null;
        } ---deprecated*/
    }, [location.pathname, exAppContext.membershipContracts, contractPayments]);

    //watch for databaseRequestAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchPayments':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const payments = [] as Payment[];
                            resObjs.map((resObj: any) => {
                                payments.push(new Payment(
                                    resObj['paymentID'],
                                    resObj['invoice_no'],
                                    resObj['type'],
                                    resObj['status'],
                                    resObj['contact_salutaiton'],
                                    resObj['contact_other_salutation'],
                                    resObj['contact_name'],
                                    resObj['contact_hp'],
                                    resObj['contact_office_no'],
                                    resObj['contact_email'],
                                    resObj['billing_name'],
                                    resObj['billing_address'],
                                    resObj['e_invoice_pin'],
                                    resObj['itemIDs'],
                                    resObj['pax'],
                                    resObj['amounts'],
                                    resObj['datetime_created'],
                                    resObj['datetime_updated'],
                                    resObj['remarks']
                                ));
                            });
                            SetContractPayments([...payments]);
                        } else {
                            console.log('fetchPaymentsErr: ' + res);
                        }
                        break;
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchPayments':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnViewModeToggled = (viewMode: number) => {
        exAppContext.SetViewMode(viewMode);
        appContext.SetStorageRequestMode('set system');
        appContext.SetStorageRequestParams([
            ['system:viewMode', viewMode]
        ]);
    }
    const GetCommitteeTypeByID = (typeID: string) => {
        let res = {} as CommitteeType;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.committee_typeID == typeID)
                res = committeeType;
        });
        return res;
    }

    //render functions
    const RenderLogoPanel = () => {
        const re_pathname = '/' + location.pathname.split('/')[1]
        if (re_pathname == '/Home')
            return (
                <div className='Header-row'>
                    <img className='Header-row-logo' src={PPKMLogoTransparent} style={ isPlatform('ios') ? {marginTop: '1vh'} : {}}/>
                    {/* <div className='Header-col-group'>
                        <span className='Header-row-title'>PPK MALAYSIA</span>
                        <span className='Header-row-lbl'>Malaysia Shopping Malls Association</span>
                    </div> ---deprecated*/}
                </div>
            )
        else
            return null
    }
    const RenderHeaderContent = () => {
        const re_pathname = '/' + location.pathname.split('/')[1];
        switch (re_pathname) {
            case '/Home':
                return (
                    <div className='Header-banner'>
                        <img className='Header-banner-bg' src={HeaderBannerBg} />
                        <div className='Header-row'>
                            <div className='Header-title-block'>
                                <span className='Header-title-title'>Welcome!</span>
                                <span className='Header-title-lbl'>{appContext.user.name}</span>
                            </div>
                            <div className='Header-nav-block'>
                                <button className='Header-nav-btn' onClick={() => history.push('/Profile')}><AccountCircleIcon /></button>
                                <button className='Header-nav-btn' onClick={() => history.push('/ViewNotifications')}>
                                    <NotificationActiveIcon />
                                    {
                                        unreadBroadcastCount > 0 ?
                                            <span className='notification-count-lbl'>{unreadBroadcastCount}</span>
                                            :
                                            null
                                    }
                                </button>
                            </div>
                        </div>

                        {/* <div className={'Header-row ex ' + (headerVisibility ? 'show' : 'hide')}>
                            <div className='Header-row-group' style={{ transform: 'translate(0, 25%)' }}>
                                <span className='Header-row-title'>Welcome!</span>
                                <span className='Header-row-txt'>{user.name}</span>
                            </div>
                            <div className='Header-row-group'>
                                <div className='Header-profile-group'>
                                    <button className='Header-nav-btn' onClick={() => history.push('/Profile')}><AccountCircleIcon /></button>
                                </div>
                                <button className='Header-nav-btn' onClick={() => history.push('/ViewNotifications')}>
                                    <NotificationActiveIcon />
                                    {
                                        unreadBroadcastCount > 0 ?
                                            <span className='notification-count-lbl'>{unreadBroadcastCount}</span>
                                            :
                                            null
                                    }
                                </button>
                            </div>
                        </div> */}
                        {/* <span className='Header-corner-badge'>{GetMembershipAccountType()}</span> ---deprecated to mode switch button*/}
                        {
                            Object.keys(appContext.user).length > 0 ?
                                appContext.user.memberID.length > 0 && appContext.user.committee_typeID.length > 0 ?
                                    <div className='Header-banner-toggle'>
                                        {/*
                                        <button className='mode-switch-toggle-btn' onClick={() => OnViewModeToggled(App_ViewModeMap.MEMBER)}>{GetMembershipTypeByID(exAppContext.membership.member_typeID).label}<span className='toggle-btn-lbl'>{GetAccountTypeByID(appContext.user.type)}</span></button>
                                        <button className='mode-switch-toggle-btn' onClick={() => OnViewModeToggled(App_ViewModeMap.COMMITTEE)}>{GetCommitteeTypeByID(appContext.user.committee_typeID).label}</button>
                                        <span className={'mode-switch-toggle-cursor ' + (exAppContext.viewMode == App_ViewModeMap.MEMBER ? 'membership' : 'committee')}>{
                                            exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                                                <Fragment>
                                                    {GetMembershipTypeByID(exAppContext.membership.member_typeID).label}
                                                    <span className='mode-switch-toggle-lbl'>{GetAccountTypeByID(appContext.user.type)}</span>
                                                </Fragment>
                                                :
                                                GetCommitteeTypeByID(appContext.user.committee_typeID).label
                                        }
                                        </span> ---deprecated*/}
                                        <ToggleSlider
                                            labelA={GetMembershipTypeByID(exAppContext.membership.member_typeID).label + GetAccountTypeByID(appContext.user.type)}
                                            labelB={GetCommitteeTypeByID(appContext.user.committee_typeID).label}
                                            toggled={exAppContext.viewMode == App_ViewModeMap.MEMBER ? false : true}
                                            SetToggled={(res: boolean) => {
                                                if (res) {
                                                    exAppContext.SetViewMode(App_ViewModeMap.COMMITTEE);
                                                } else {
                                                    exAppContext.SetViewMode(App_ViewModeMap.MEMBER);
                                                }
                                            }}
                                        />
                                    </div>
                                    :
                                    (
                                        appContext.user.memberID.length > 0 ?
                                            //render membership membertype
                                            <span className='Header-banner-mode-lbl membership'>{GetMembershipTypeByID(exAppContext.membership.member_typeID).label + GetAccountTypeByID(appContext.user.type)}</span>
                                            :
                                            (
                                                appContext.user.committee_typeID.length > 0 ?
                                                    //render committee type
                                                    <span className='Header-banner-mode-lbl committee'>{GetCommitteeTypeByID(appContext.user.committee_typeID).label}</span>
                                                    :
                                                    <span className='Header-banner-mode-lbl dummy'></span>
                                            )
                                    )
                                :
                                null
                        }
                    </div>
                );
            case '/ViewNotifications':
            case '/ViewEvents':
            case '/Events':
            case '/MyEvents':
            case '/EventRegistrations':
            case '/Profile':
            case '/ManageMembership':
            case '/EditProfile':
            case '/ChangePassword':
            case '/ResetPin':
            case '/ECert':
            // case '/MembershipRenewal': ---deprecated
            case '/SecondaryAccount':
            case '/MembersList':
            case '/Miscellaneous':
            case '/ViewEventGallery':
            case '/ViewDocuments':
            case '/ViewMeetings':
            case '/ViewPolls':
            case '/ManageNotifications':
            case '/ManageEventAttachments':
            case '/SocialMedia':
                return (
                    <div className='Header-banner ex'>
                        <img className='Header-banner-bg ex' src={HeaderBannerBg} />
                        {
                            headerBackAction != null ?
                                <button className='Header-back-btn' onClick={() => { headerBackAction() }}><ArrowBackIosIcon /></button>
                                :
                                null
                        }
                        <span className='Header-title-lbl'>{headerTitle}</span>
                    </div>
                )

        }
    }
    // const RenderGraceCountdownBlock = () => {
    //     const [days, hours, minutes, seconds] = ToInterval(graceCountdownTime);

    //     return(
    //         <div className='grace-countdown-block'>
    //             <PlayArrow />
    //             <span className='grace-countdown-block-lbl'>{`Membership expired, account suspension in ${days}D ${hours}H ${minutes}M ${seconds}S`}</span>
    //         </div>
    //     );
    // } ---deprecated

    //exe functions
    const HeaderTitleControl = (pathname: string) => {
        const pathNameArr = pathname.split('/');
        let _pathName = ('/' + pathNameArr[1]);
        if (pathNameArr.length >= 3)
            _pathName += ('/' + pathNameArr[2]);

        switch (_pathName) {
            case '/ViewNotifications':
                appContext.SetHeaderTitle('Notifications');
                // exAppContext.viewMode == App_ViewModeMap.MEMBER ?
                //     appContext.SetHeaderBackAction(() => () => { history.push('/Home') })
                //     :
                //     appContext.SetHeaderBackAction(() => () => { history.push('/Profile') }) --deprecated
                appContext.SetHeaderBackAction(() => () => { history.push('/Home') })
                break;
            // case '/ViewEvents':
            //     appContext.SetHeaderTitle('MY EVENTS');
            //     break;
            case '/Events':
                appContext.SetHeaderTitle('PPKM EVENTS');
                break;
            case '/MyEvents':
            case '/MyEvents/0':
            case '/MyEvents/1':
            case '/MyEvents/2':
            case '/MyEvents/3':
            case '/MyEvents/4':
                appContext.SetHeaderTitle('MY EVENTS');
                break;
            case '/EventRegistrations':
                appContext.SetHeaderTitle('Event Registrations');
                break;
            case '/Profile':
                appContext.SetHeaderTitle('Profile');
                if (exAppContext.viewMode == App_ViewModeMap.MEMBER)
                    appContext.SetHeaderBackAction(() => () => { history.push('/Home') });
                else
                    appContext.SetHeaderBackAction(null);
                break;
            case '/EditProfile':
                appContext.SetHeaderTitle('Edit Profile');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Profile');
                });
                break;
            case '/EditProfile/Secondary':
                appContext.SetHeaderTitle('Edit Profile');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/SecondaryAccount');
                });
                break;
            case '/ChangePassword':
                appContext.SetHeaderTitle('Change Password');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Profile');
                });
                break;
            case '/ResetPin':
                appContext.SetHeaderTitle('Reset Pin');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Profile');
                });
                break;
            case '/ECert':
                appContext.SetHeaderTitle('E-Certificate');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Profile');
                });
                break;
            case '/ManageMembership':
                appContext.SetHeaderTitle('Membership');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Profile');
                });
                break;
            case '/SocialMedia':
                appContext.SetHeaderTitle('Social Media');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Home');
                });
                break;
            case '/SecondaryAccount':
                appContext.SetHeaderTitle('Secondary Account');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Home');
                });
                break;
            case '/ViewEventGallery/Member':
            case '/ViewEventGallery/Committee':
                appContext.SetHeaderTitle('Photo Gallery');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Home');
                });
                break;
            // case '/ViewEventGallery/Committee':
            //     appContext.SetHeaderTitle('Manage Event Gallery');
            //     appContext.SetHeaderBackAction(() => () => {
            //         history.push('/Profile');
            //     });
            //     break;
            case '/ViewDocuments/Member':
            case '/ViewDocuments/Committee':
            case '/ViewDocuments/Newsletter':
                appContext.SetHeaderTitle('View Resources');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Home');
                });
                break;
            // case '/ViewDocuments/Committee':
            //     appContext.SetHeaderTitle('Manage Documents');
            //     appContext.SetHeaderBackAction(() => () => {
            //         history.push('/Profile');
            //     });
            //     break;
            case '/ViewMeetings':
            case '/ViewMeetings/Invitations':
                appContext.SetHeaderTitle('Meetings');
                appContext.SetHeaderBackAction(() => () => {
                    history.push('/Home');
                    // history.push('/Profile');
                });
                break;
            case '/ViewPolls':
            case '/ViewPolls/NewPolls':
            case '/ViewPolls/HostedPolls':
                appContext.SetHeaderTitle('Polls');
                appContext.SetHeaderBackAction(() => () => {
                    // history.push('/Profile');
                    history.push('/Home');
                });
                break;
            case '/MembersList':
                appContext.SetHeaderTitle('PPKM Members');
                appContext.SetHeaderBackAction(() => () => {
                    // history.push('/Profile');
                    history.push('/Profile');
                });
                break;
            case '/ManageNotifications':
                appContext.SetHeaderTitle('Manage Notifications');
                appContext.SetHeaderBackAction(() => () => {
                    // history.push('/Profile');
                    history.push('/Home');
                });
                break;
            case '/ManageEventAttachments':
                appContext.SetHeaderTitle('Manage Attachments');
                appContext.SetHeaderBackAction(() => () => {
                    // history.push('/Profile');
                    history.push('/Home');
                });
                break;
        }
    }
    // const GetMembershipAccountType = () => {
    //     let res = "";
    //     if (IsCorporate()) {
    //         res = GetMembershipTypeByID(exAppContext.membership.member_typeID) + GetAccountTypeByID(appContext.user.type);
    //     } else {
    //         res = GetMembershipTypeByID(exAppContext.membership.member_typeID);
    //     }
    //     return res;
    // } ---deprecated
    const GetMembershipTypeByID = (typeID: string) => {
        let res = {} as MemberType;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (memberType.member_typeID == typeID)
                res = memberType;
        });
        return res;
    }
    const GetAccountTypeByID = (typeID: string) => {
        let res = '';
        if (IsCorporate()) {
            if (typeID == MemberUser_TypeMap.APPOINTED)
                return '/Appt.';
            else if (typeID == MemberUser_TypeMap.ALTERNATE)
                return '/Alt.';
            else if (typeID == MemberUser_TypeMap.OTHERS)
                return '/Oth.';
        }
        return res;
    }
    // const CapitalizeInitial = (subject: string) => {
    //     return subject.substring(0, 1).toUpperCase() + subject.substring(1, subject.length);
    // } ---deprecated
    //check function
    const IsCorporate = () => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                memberType.member_typeID == exAppContext.membership.member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            ) {
                res = true;
            }
        });
        return res;
    }
    const SortMembershipContracts = (membershipContracts: MembershipContract[]) => {
        //sort by datetime created descending
        const sorted = [] as MembershipContract[];
        membershipContracts.map((membershipContract: MembershipContract) => {
            let isSorted = false;
            sorted.map((_membershipContract: MembershipContract, i: number) => {
                if (
                    !isSorted &&
                    (
                        (
                            membershipContract.min_term != null &&
                            _membershipContract.min_term != null &&
                            membershipContract.min_term > _membershipContract.min_term
                        )
                        ||
                        (
                            membershipContract.datetime_created != null &&
                            _membershipContract.datetime_created != null &&
                            membershipContract.datetime_created > _membershipContract.datetime_created
                        )
                    )
                ) {
                    sorted.splice(i, 0, membershipContract);
                    isSorted = true;
                }
            });

            if (!isSorted)
                sorted.push(membershipContract);
        });
        return sorted;
    }
    const GetContractPaymentByID = (_contractPayments: Payment[], paymentID: string) => {
        let res = {} as Payment;
        _contractPayments.map((payment: Payment) => {
            if (payment.paymentID == paymentID)
                res = payment;
        })
        return res;
    }
    const GetLastRenewedContract = (membershipContracts: MembershipContract[]) => {
        const sorted = SortMembershipContracts(membershipContracts);

        let res = {} as MembershipContract;
        let isFound = false;
        sorted.map((contract: MembershipContract) => {
            const contractPayment = GetContractPaymentByID(contractPayments, contract.paymentID);
            if (!isFound && contractPayment.status == Payment_StatusMap.PAID) {
                res = contract;
                isFound = true;
            }
        });
        return res;
    }

    //conversion function
    const ToInterval = (time: number) => {
        const days = Math.floor(time / (24 * 3600)); // 1 day = 24 hours * 3600 seconds
        const hours = Math.floor((time % (24 * 3600)) / 3600); // 1 hour = 3600 seconds
        const minutes = Math.floor((time % 3600) / 60); // 1 minute = 60 seconds
        const remainingSeconds = time % 60;

        return [days.toString().padStart(2, '0'), hours.toString().padStart(2, '0'), minutes.toString().padStart(2, '0'), remainingSeconds.toString().padStart(2, '0')];
    }

    return (
        <div className={"Header " + headerMode + " " + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className={'Header-bg'/* + ((graceCountdownTime > 0 && location.pathname == '/Home') ? ' corner-squared' : '') --deprecated*/} />
            {RenderLogoPanel()}
            {RenderHeaderContent()}
            {/* {
                graceCountdownTime > 0 && location.pathname == '/Home' ?
                RenderGraceCountdownBlock()
                :
                null
            } ---deprecated */}
        </div>
    );
};

export default Header;